import styled from 'styled-components';
import { HEADER_HEIGHT } from '../../assets/styles/layout/mainLayout.styled';

/* Stands in for the main layout when an exception takes the app down before it renders, so it
   repeats that layout's spacing: the fixed header is cleared with padding, and the bottom is
   left to the page's own gutter class the same way the main layout leaves it. */
export const ErroPageWrapper = styled.div`
  padding: calc(${HEADER_HEIGHT} + var(--spacing-gutter)) var(--spacing-gutter) 0;
  background-color: var(--clr-container-bg);
  height: var(--viewport-height);
  min-height: var(--viewport-height);
  position: relative;
  .main-header {
    padding: 10px var(--spacing-gutter);
    font-weight: 600;
    width: 100%;
    background: var(--clr-container-bg);
    position: fixed;
    top: 0;
    left: 0;
    font-size: 14px;
    color: var(--clr-title);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    height: ${HEADER_HEIGHT};
  }
`;
